import {useEffect, useState} from "react";
import styles from "./AdminDashboard.module.css";
import Header from "../../components/Header/Header";
import AdminSideBar from "../../components/SideBar/SideBar";
import Footer from "../../components/footer/Footer";
import Seta from '../../assets/SetaDireita.svg';
import {useTranslation} from "react-i18next";
import api from "../../utils/axios/api"

function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState<boolean>(false);
  
    useEffect(() => {
      const media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
  
      const listener = () => {
        setMatches(media.matches);
      };
  
      media.addEventListener('change', listener);
      return () => media.removeEventListener('change', listener);
    }, [matches, query]);
  
    return matches;
  }



export default function AdminDashboard(){
    const isSmallScreen = useMediaQuery('(max-width: 768px)');
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [UserQuantity, setUserQuantity] = useState(0);
    const [StoreQuantity, setStoreQuantity] = useState(0);
    const [ProductQuantity, setProductQuantity] = useState(0);
    const [OrderQuantity, setOrderQuantity] = useState(0);

    const token = localStorage.getItem('token')

    const fetchData = async () => {
        try {
          //Quantidade de Usuários
          const UserResponse = await api.get('/admin/user')
          setUserQuantity(UserResponse.data.length)
          
          //Quantidade de loja
          const StoreResponse = await api.get('/store', {
            headers:{
                Authorization: `Bearer ${token}` 
            }
          })
          setStoreQuantity(StoreResponse.data.length)
          
          //Quantidade de Produtos
          const ProductResponse = await api.get('/product')
          setProductQuantity(ProductResponse.data.length)

          //Quantidade de Pedidos
          const OrderResponse = await api.get('/order', {
            headers:{
                Authorization: `Bearer ${token}` 
            }
          })
          setOrderQuantity(OrderResponse.data.length)
    
        } catch (error) {
          alert('Erro ao fazer login.')
        }
      }

    const toggleMobileMenu = () => {
        setMobileMenuActive(mobileMenuActive);
    };

    const { t } = useTranslation("translation", {keyPrefix: "admindashboard"})

    useEffect(() => {
        fetchData()
    }, [])

    return(
      <>
          <Header 
          boxShadow
          toggleMobileMenu={toggleMobileMenu}
          mobileMenuActiveState={mobileMenuActive}
          isSmallScreen={isSmallScreen}
        />
          <main className={styles.mainContainer}>
            <section className={styles.sectionContainer}>


                <div className={styles.caminho}>
                    <div className={styles.item}>
                        <a href="/">{t('minhaConta')}</a>
                    </div>
                    <div className={styles.img_seta}>
                        <img src={Seta} alt="seta" />
                    </div>
                    <div className={styles.local}>
                    <span>Dashboard</span>
                    </div>
                </div>

                <div className={styles.tituloContainer}>
                    <p className={styles.titulo}>{t('dashboard')}</p>
                </div>
                

                <div className={styles.taxa}>
                    <div>
                        <p className={styles.texto}>{t('quantidadeUsuarios')}{UserQuantity}</p>
                    </div>
                </div>

                <div className={styles.taxa}>
                    <div>
                        <p className={styles.texto}>{t('quantidadeLojas')}{StoreQuantity}</p>
                    </div>
                </div>

                <div className={styles.taxa}>
                    <div>
                        <p className={styles.texto}>{t('quantidadeProdutos')}{ProductQuantity}</p>
                    </div>
                </div>

                <div className={styles.taxa}>
                    <div>
                        <p className={styles.texto}>{t('quantidadePedidos')}{OrderQuantity}</p>
                    </div>
                </div>

            </section>
            <aside className={styles.asideContainer}>
                <AdminSideBar />
            </aside>
          </main>
          {!isSmallScreen && (<Footer />)}
      </>
    )
  }